export default {
  name: 'infrequentVisitorSignOut',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction
      .methodRequest(`/sites/visitors/infrequent/${data.id}`, 'POST', data)
  },
  restoreSave: (ctx) => {
    const data = ctx.saveObj.data;
    ctx.router.push({ name: `sites-siteid-view-visitors`, params: { siteid: data.siteid } })
  }
}
